import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollManager from './components/ScrollManager';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <Router>
      <ScrollManager />
      <div className="flex min-h-screen flex-col bg-paper text-ink">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            {/* Legacy URLs from the previous site */}
            <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
            <Route path="/Terms-Of-Use" element={<Navigate to="/terms" replace />} />
            <Route path="/About-us" element={<Navigate to="/#about" replace />} />
            <Route path="/Contact-Us" element={<Navigate to="/#contact" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
